import { render } from "./addComment.vue?vue&type=template&id=09f1a60e&scoped=true"
import script from "./addComment.vue?vue&type=script&lang=js"
export * from "./addComment.vue?vue&type=script&lang=js"

import "./addComment.vue?vue&type=style&index=0&id=09f1a60e&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f1a60e"]])

export default __exports__